// extracted by mini-css-extract-plugin
export var copies = "Hero-module--copies--EtbFI";